// Components
import { ClosableModal } from '@Components/shared/dialogs/ClosableModal';
// Form
import { CreateProviderConfigForm } from './CreateProviderConfigForm';
// Redux
import { useCreateProviderConfig } from '@Modal/hooks/providers/useCreateProviderConfig';
// Styles
import Styles from './CreateProviderConfigModalDialog.module.scss';

export const CreateProviderConfigModalDialog = () => {
  const { showCreateProviderConfigForm, handleCreateCancel } = useCreateProviderConfig();
  return (
    <>
      {showCreateProviderConfigForm && (
        <ClosableModal
          name="CreateProviderConfig"
          title="Add Provider Config"
          open={showCreateProviderConfigForm}
          onClose={handleCreateCancel}
          className={Styles.CreateProviderConfigModalDialog}
          sx={{ height: '90vh', overflowY: 'scroll', width: '592px' }}
        >
          <CreateProviderConfigForm />
        </ClosableModal>
      )}
    </>
  );
};
